import { getCookie } from "./ts-utils"

const OPTOUTMULTI_COOKIE = "OPTOUTMULTI"

/**
 * Parse the OPTOUTMULTI cookie into its named category values, e.g. { c1: "0", c7: "0", c8: "0", c9: "0" }.
 * @param optoutMulti Raw OPTOUTMULTI cookie value, e.g. "0:0|0:0|c1:0|c7:0|c8:0|c9:0"
 */
export const parseOptOutMulti = (optoutMulti: string | null): Record<string, string> => {
    const parsed: Record<string, string> = {}
    ;(optoutMulti || "").split("|").forEach(part => {
        const [key, value] = part.split(":")
        if (key && value !== undefined) parsed[key] = value
    })
    return parsed
}

/**
 * Whether the user currently has c8 ("Improve your experience" — FullStory/Amplitude) tracking consent.
 *
 * Lives in its own module (rather than cookieConsent.ts) so that amplitude/intercom event logging
 * can depend on it without creating a circular import with cookieConsent.ts.
 */
export const hasTrackingConsent = (): boolean => parseOptOutMulti(getCookie(OPTOUTMULTI_COOKIE)).c8 === "0"
